// templateConstants.js - All constants, configs, and option getters

export const SCREEN_TO_VIEW_TYPE = {
  brandPerformance: 11,
  marketShare: 6,
};

export const FIELD_MAPPINGS = {
  'Brand Name': ['brand', 'brand.keyword', 'brand_name'],
  'Retailer': ['rootdomain', 'rootdomain.keyword'],
  'Search Term': [
    'search_terms_kpis.search_term',
    'searchterm',
    'search_term',
    'searchTerm',
    'keywords',
    'keyword'
  ],
  'Competitor Name': ['competitor', 'competitor_name'],
  'Product Category': ['category', 'category.keyword', 'mb_category'],
};

export const FIELD_TYPE_MAP = {
  'Brand Name': 'Brand Name',
  'Retailer': { default: 'Retailer', 'Sales Performance': 'Retailer Multi' },
  'Search Term': { default: 'Search Term', 'Visibility Performance': 'Search Term Multi' },
  'Competitor Name': 'Competitor Name',
  'Product Category': { default: 'Product Category', 'Sales Performance': 'Product Category Multi' },
  'Date/Time Period': 'Date Range',
  'Start Date': 'Date Range',
  'End Date': 'Date Range',
  'Amount': 'Text Input',
  'increased/decreased': 'Change Direction',
  'Number': 'Number Dropdown',
  'Compare Period': 'Compare Period',
  'Metric Type': 'Metric Type',
  'Mover Type': 'Mover Type',
  'SKU Mover Type': 'SKU Mover Type',
};

export const FIELD_SORT_ORDER = {
  'Retailer': 1,
  'Product Category': 2,
  'Brand Name': 3,
  'Search Term': 4,
  'Date Range': 5,
  'Compare Period': 6,
  'Metric Type': 7,
  'Mover Type': 8,
  'Number Dropdown': 9,
  'Change Direction': 10,
  'Text Input': 11,
  'Competitor Name': 12,
};

// Simple dropdown options
export const DROPDOWN_OPTIONS = {
  'Number Dropdown': [
    { id: 1, value: '1', label: '1' },
    { id: 2, value: '2', label: '2' },
    { id: 3, value: '3', label: '3' },
    { id: 4, value: '4', label: '4' },
    { id: 5, value: '5', label: '5' },
    { id: 6, value: '6', label: '6' },
    { id: 7, value: '7', label: '7' },
    { id: 8, value: '8', label: '8' },
    { id: 9, value: '9', label: '9' },
    { id: 10, value: '10', label: '10' },
  ],
  'Change Direction': [
    { id: 1, value: 'increased', label: 'Increased' },
    { id: 2, value: 'decreased', label: 'Decreased' },
  ],
  'Compare Period': [
    { id: 1, value: 'previous period', label: 'Previous Period' },
    { id: 2, value: 'previous year', label: 'Previous Year' },
    { id: 3, value: 'last year same period', label: 'Last Year Same Period' },
  ],
  'Metric Type': [
    { id: 1, value: 'Units', label: 'Units' },
    { id: 2, value: 'Revenue', label: 'Revenue' },
  ],
  'Mover Type': [
    { id: 1, value: 'top sellers', label: 'Top Sellers' },
    { id: 2, value: 'trending', label: 'Top Trending' },
    { id: 3, value: 'losses', label: 'Top Losing' },
  ],
  'SKU Mover Type': [
    { id: 1, value: 'top sellers', label: 'Top Sellers' },
    { id: 2, value: 'trending', label: 'Top Trending' },
    { id: 3, value: 'losses', label: 'Top Losing' },
  ],
};

// Field configuration for rendering
export const FIELD_CONFIG = {
  'Date Range': {
    type: 'date',
    hasPresets: true,
  },
  'Number Dropdown': {
    type: 'simple',
    placeholder: 'Select number...',
  },
  'Change Direction': {
    type: 'simple',
    placeholder: 'Select direction...',
  },
  'Compare Period': {
    type: 'simple',
    placeholder: 'Select comparison...',
  },
  'Metric Type': {
    type: 'simple',
    placeholder: 'Select metric...',
  },
  'Mover Type': {
    type: 'simple',
    placeholder: 'Select type...',
  },
  'SKU Mover Type': {
    type: 'simple',
    placeholder: 'Select type...',
  },
};

// Get options for a simple dropdown field
export const getSimpleOptions = (fieldType) => {
  return DROPDOWN_OPTIONS[fieldType] || [];
};
